/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "5fM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EbM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.less
var style = __webpack_require__("EbM4");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/theatre/style.less
var theatre_style = __webpack_require__("5fM0");
var theatre_style_default = /*#__PURE__*/__webpack_require__.n(theatre_style);

// EXTERNAL MODULE: ./components/player/style.less
var player_style = __webpack_require__("takr");
var player_style_default = /*#__PURE__*/__webpack_require__.n(player_style);

// CONCATENATED MODULE: ./components/bridge.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bridge = function () {
	function Bridge(el) {
		_classCallCheck(this, Bridge);

		this.el = el;
		this.callbacks = {};
		this.eventsObject = {};
	}

	Bridge.prototype.createId = function createId() {
		var cbId = Math.round(Math.random() * 999999999);
		while (cbId in this.callbacks) {
			cbId = Math.round(Math.random() * 999999999);
		}
		return cbId;
	};

	Bridge.prototype.createPromise = function createPromise(id, message) {
		var _this = this;

		return new Promise(function (resolve, reject) {
			_this.el.contentWindow.postMessage(message, '*');

			_this.callbacks[id] = _this.callbacks[id] || {};
			_this.callbacks[id].resolve = resolve;
			_this.callbacks[id].reject = reject;
		});
	};

	Bridge.prototype.postMessage = function postMessage(params) {
		var id = '' + this.createId();
		var message = JSON.stringify({ api: params.api, data: params.data, id: id });

		this.callbacks[id] = this.callbacks[id] || {};
		this.callbacks[id].context = params.ctx;
		this.callbacks[id].promise = this.createPromise(id, message);

		return this.callbacks[id].promise;
	};

	Bridge.prototype.getCallback = function getCallback(id, data) {
		var item = this.callbacks[id];
		item && item.resolve(data);
		delete this.callbacks[id];
	};

	return Bridge;
}();


// CONCATENATED MODULE: ./helper.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function request(url, options) {
	return new Promise(function ($return, $error) {
		var fetchOpt, response;

		fetchOpt = {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, *cors, same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				'Content-Type': 'application/json'
			},
			redirect: 'follow', // manual, *follow, error
			referrerPolicy: 'no-referrer' // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
		};
		return Promise.resolve(fetch(url, _extends({}, fetchOpt, options))).then(function ($await_1) {
			try {
				response = $await_1;
				return $return(response.json());
			} catch ($boundEx) {
				return $error($boundEx);
			}
		}, $error);
	});
}

var config = {
	DOMAIN: window.location.hostname === 'localhost' ? 'https://stagingwt.wootag.com' : window.location.origin
};

function getPreviewModes(data) {
	return new Promise(function ($return, $error) {
		var res;
		return Promise.resolve(request(config.DOMAIN + '/api/v1/auth/video/guid/' + data.videoUUID, {
			method: 'GET'
		})).then(function ($await_2) {
			try {
				res = $await_2;
				return $return(res);
			} catch ($boundEx) {
				return $error($boundEx);
			}
		}, $error);
	});
}

function getDataJson(data) {
	return new Promise(function ($return, $error) {
		var res;
		return Promise.resolve(request(config.DOMAIN + '/api/v2/datajson/' + data.bucketID + '/' + data.videoUUID + '?mode=preview', {
			method: 'GET'
		})).then(function ($await_3) {
			try {
				res = $await_3;
				return $return(res);
			} catch ($boundEx) {
				return $error($boundEx);
			}
		}, $error);
	});
}

function mobileCheck() {
	var check = false;
	(function (a) {
		// eslint-disable-next-line no-useless-escape
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}

function landscapeCheck() {
	return window.innerWidth > window.innerHeight;
}

function getVideoID() {
	var urlBucketAndUUID = window.location.pathname.substr(window.location.pathname.lastIndexOf('/'));
	var bucketID = urlBucketAndUUID && urlBucketAndUUID.substr(1, 16);
	var videoUUID = urlBucketAndUUID && urlBucketAndUUID.substr(17);
	return { bucketID: bucketID, videoUUID: videoUUID };
}

function getUrlParams() {
	var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
}
// CONCATENATED MODULE: ./components/player/index.js


function player__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/sort-comp */
/* eslint-disable no-mixed-spaces-and-tabs */






var _ref = Object(preact_min["h"])(
	'div',
	{ 'class': 'dummy-lines thick' },
	Object(preact_min["h"])('div', { 'class': 'dummy-line wide' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line narrow' })
);

var _ref2 = Object(preact_min["h"])(
	'div',
	{ 'class': 'dummy-lines thin' },
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line full' }),
	Object(preact_min["h"])('div', { 'class': 'dummy-line narrow' })
);

var player_Player = function (_Component) {
	_inherits(Player, _Component);

	function Player(props) {
		player__classCallCheck(this, Player);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.handleSlider = function (direction) {
			var mode = _this.props.checkModeAvailability(_this.props.mode, direction);
			_this.props.modeSelector(mode);
		};

		_this.callBridge = function (api, data, cb) {
			if (_this.bridge && _this.bridge.postMessage) {
				return _this.bridge.postMessage({
					api: api,
					data: data,
					ctx: _this,
					cb: cb
				});
			}
		};

		_this.origin = window.location.hostname === 'localhost' ? config.DOMAIN + '/videos/share/v2' : window.location.origin;

		var _Helper$getVideoID = getVideoID(),
		    bucketID = _Helper$getVideoID.bucketID,
		    videoUUID = _Helper$getVideoID.videoUUID;

		_this.pathname = '/' + bucketID + videoUUID;

		if (typeof wootag_video_id !== 'undefined') {
			var href = window.location.href;
			var patterns = href.match(/((http|https):\/\/)?(([\w.-]*)\.([\w]*))\/project\/preview\/([A-Za-z0-9]{6}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4})\/([A-Za-z0-9]{4})/);

			if (patterns && patterns[6]) {
				_this.pathname = '/' + patterns[6] + wootag_video_id;
			}
		}
		var urlParams = getUrlParams() || {};
		var paramsToPass = '';
		Object.keys(urlParams).forEach(function (key, idx) {
			if (key) {
				paramsToPass += '&' + key + '=' + urlParams[key];
			}
		});
		_this.url = window.location.hostname === 'localhost' ? '' + _this.origin + _this.pathname + '?previewlink=1' + paramsToPass : _this.origin + '/videos/share/v2' + _this.pathname + '?previewlink=1' + paramsToPass;
		return _this;
	}

	Player.prototype.componentDidMount = function componentDidMount() {
		this.bridge = new Bridge(this.iframe);
	};

	Player.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.mode && this.props.mode !== nextProps.mode || nextProps.playerReady && nextProps.playerReady !== this.props.playerReady) {
			if (nextProps.mode === 1) {
				this.callBridge('forceDesktopEmulation');
			} else {
				this.callBridge('forceMobileEmulation');
			}
		}
	};

	Player.prototype.render = function render(props, state) {
		var _this2 = this;

		var availableModes = props.availableModes,
		    aspectRatio = props.aspectRatio;

		var modesLength = availableModes && availableModes.length;
		var paddingTop = aspectRatio * 100;
		var maxWidth = paddingTop > 75 ? '600px' : '100%';
		return Object(preact_min["h"])(
			'div',
			{ 'class': 'player-area-wrapper mode-' + props.mode + ' ' + (props.hideControls ? 'hideControls' : '') },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'maxWidthSetter', style: { width: '100%', maxWidth: maxWidth } },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'player-container', style: props.mode === 1 ? { paddingTop: paddingTop + '%' } : {} },
					Object(preact_min["h"])(
						'div',
						{ 'class': 'embed-wrapper' },
						_ref,
						Object(preact_min["h"])(
							'div',
							{ 'class': 'player-cover', style: props.mode === 3 ? { paddingTop: paddingTop + '%' } : {} },
							Object(preact_min["h"])('iframe', { ref: function ref(c) {
									return _this2.iframe = c;
								}, allowFullScreen: true, src: this.url })
						),
						_ref2
					)
				)
			),
			modesLength > 1 && Object(preact_min["h"])('div', { 'class': 'arrow back', onClick: this.handleSlider.bind(this, 'back') }),
			modesLength > 1 && Object(preact_min["h"])('div', { 'class': 'arrow next', onClick: this.handleSlider.bind(this, 'next') })
		);
	};

	return Player;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/controls/style.less
var controls_style = __webpack_require__("Xkos");
var controls_style_default = /*#__PURE__*/__webpack_require__.n(controls_style);

// CONCATENATED MODULE: ./components/controls/index.js


function controls__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function controls__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function controls__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var controls__ref = Object(preact_min["h"])('div', { 'class': 'wootag-logo' });

var controls_Controls = function (_Component) {
  controls__inherits(Controls, _Component);

  function Controls() {
    var _temp, _this, _ret;

    controls__classCallCheck(this, Controls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = controls__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.selector = function (mode) {
      _this.props.modeSelector(mode);
    }, _temp), controls__possibleConstructorReturn(_this, _ret);
  }

  Controls.prototype.render = function render(props, state) {
    var availableModes = props.availableModes;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'controls' },
      controls__ref,
      Object(preact_min["h"])(
        'ul',
        null,
        availableModes.includes(1) && availableModes.length > 1 && Object(preact_min["h"])(
          'li',
          {
            'class': 'mode1 ' + (props.mode === 1 ? 'active' : ''),
            onClick: this.selector.bind(this, 1)
          },
          'Desktop'
        ),
        availableModes.includes(2) && availableModes.length > 1 && Object(preact_min["h"])(
          'li',
          {
            'class': 'mode2 ' + (props.mode === 2 ? 'active' : ''),
            onClick: this.selector.bind(this, 2)
          },
          'Mobile Interstitial'
        ),
        availableModes.includes(3) && availableModes.length > 1 && Object(preact_min["h"])(
          'li',
          {
            'class': 'mode3 ' + (props.mode === 3 ? 'active' : ''),
            onClick: this.selector.bind(this, 3)
          },
          'Mobile Embed'
        )
      )
    );
  };

  return Controls;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/theatre/index.js


function theatre__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function theatre__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function theatre__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-mixed-spaces-and-tabs */







var theatre_Theatre = function (_Component) {
  theatre__inherits(Theatre, _Component);

  function Theatre(props) {
    theatre__classCallCheck(this, Theatre);

    var _this = theatre__possibleConstructorReturn(this, _Component.call(this, props));

    _this.checkModeAvailability = function (num, direction, modes) {
      var availableModes = modes || _this.props.availableModes;
      var len = 3;
      var mode = void 0;
      if (direction === 'back') {
        mode = num === 1 ? len : num - 1;
        return availableModes.includes(mode) ? mode : _this.checkModeAvailability(mode, direction, availableModes);
      } else if (direction === 'next') {
        mode = num === len ? 1 : num + 1;
        return availableModes.includes(mode) ? mode : _this.checkModeAvailability(mode, direction, availableModes);
      }
    };

    _this.modeSelector = function (mode) {
      _this.setState({
        mode: mode
      });
    };

    var desktopMode = 1;
    if (_this.props.availableModes.length) {
      desktopMode = _this.props.availableModes.includes(1) ? 1 : _this.checkModeAvailability(1, 'next');
    }
    _this.state = {
      mode: props.ismobile ? props.islandscape ? 2 : _this.props.availableModes.includes(3) ? 3 : 2 : desktopMode
    };
    return _this;
  }

  Theatre.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.islandscape !== nextProps.islandscape || this.props.ismobile !== nextProps.ismobile || this.props.availableModes.length !== nextProps.availableModes.length) {
      var desktopMode = 1;
      if (nextProps.availableModes.length) {
        desktopMode = nextProps.availableModes.includes(1) ? 1 : this.checkModeAvailability(1, 'next', nextProps.availableModes);
      }
      this.setState({
        mode: nextProps.ismobile ? nextProps.islandscape ? 2 : nextProps.availableModes.includes(3) ? 3 : 2 : desktopMode
      });
    }
  };

  // eslint-disable-next-line react/sort-comp


  Theatre.prototype.render = function render(props, state) {
    var availableModes = props.availableModes;
    var onlyInterstitial = availableModes.length === 1 && availableModes.includes(2);
    var isMobile = mobileCheck();
    var hideControls = isMobile && onlyInterstitial;
    return Object(preact_min["h"])(
      'div',
      { 'class': 'previewlink-app ' + props.parentclass },
      Object(preact_min["h"])(player_Player, {
        hideControls: hideControls,
        modeSelector: this.modeSelector,
        mode: state.mode,
        playerReady: this.props.playerReady,
        availableModes: this.props.availableModes,
        checkModeAvailability: this.checkModeAvailability,
        aspectRatio: this.props.aspectRatio
      }),
      !hideControls && Object(preact_min["h"])(controls_Controls, { modeSelector: this.modeSelector, mode: state.mode, availableModes: this.props.availableModes })
    );
  };

  return Theatre;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable comma-dangle */




var app_App = function (_Component) {
	app__inherits(App, _Component);

	function App(props) {
		app__classCallCheck(this, App);

		var _this = app__possibleConstructorReturn(this, _Component.call(this, props)); // eslint-disable-line


		_this.state = {
			availableModes: [],
			playerReady: false,
			aspectRatio: 0.5625
		};
		_this.onPlayerLoad = _this.onPlayerLoad.bind(_this);
		_this.communicator = _this.communicator.bind(_this);
		return _this;
	}

	App.prototype.communicator = function communicator(event) {
		var cmd = void 0;

		try {
			cmd = JSON.parse(event.data);
		} catch (e) {}

		if (cmd && cmd.api) {
			switch (cmd.api) {
				case 'playerReady':
					this.onPlayerLoad();
					break;
			}
		}
	};

	App.prototype.onPlayerLoad = function onPlayerLoad() {
		this.setState({ playerReady: true });
	};

	App.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		window.addEventListener('message', this.communicator);
		window.addEventListener('resize', function () {
			_this2.forceUpdate();
		});

		var _Helper$getVideoID = getVideoID(),
		    videoUUID = _Helper$getVideoID.videoUUID,
		    bucketID = _Helper$getVideoID.bucketID;

		var apiCalls = function apiCalls() {
			return new Promise(function ($return, $error) {
				var data, urlParams, _previewModes, _availableModes, modes, previewModes, availableModes, aspectRatio, datajson, isSkinEnabled, skinOrientation, isHorizontaSkin, isVerticalSkin;

				data = void 0;
				urlParams = getUrlParams();
				var $Try_2_Post = function () {
					try {

						modes = urlParams.modes || '';

						previewModes = data && data.preview_list && data.preview_list.split(' ').join('');
						previewModes = previewModes + ',' + modes;
						availableModes = [];
						['desktop', 'interstitial', 'embed'].forEach(function (mode, idx) {
							if (previewModes.includes(mode)) {
								availableModes.push(idx + 1);
							}
						});
						_this2.setState({ availableModes: availableModes });
						aspectRatio = void 0;
						if (previewModes.includes('16by9')) {
							aspectRatio = 0.5625;
							return $If_3.call(this);
						} else {
							return Promise.resolve(getDataJson({ bucketID: bucketID, videoUUID: videoUUID })).then(function ($await_4) {
								try {
									datajson = $await_4;

									isSkinEnabled = datajson && datajson.custom && datajson.custom.customskin && datajson.custom.customskin.enableSkin;
									skinOrientation = isSkinEnabled && datajson && datajson.custom && datajson.custom.customskin && datajson.custom.customskin && datajson.custom.customskin.skinOrientation;
									isHorizontaSkin = isSkinEnabled && skinOrientation === 'horizontal';
									isVerticalSkin = isSkinEnabled && skinOrientation !== 'horizontal';
									aspectRatio = isHorizontaSkin ? 0.5625 : isVerticalSkin ? 1.77 : datajson && datajson.aspect_ratio || 0.5625;
									return $If_3.call(this);
								} catch ($boundEx) {
									return $error($boundEx);
								}
							}.bind(this), $error);
						}

						function $If_3() {
							_this2.setState({ aspectRatio: aspectRatio });
							return $return();
						}
					} catch ($boundEx) {
						return $error($boundEx);
					}
				};var $Try_2_Catch = function (error) {
					try {
						_previewModes = urlParams.modes || '';
						_availableModes = [];
						['desktop', 'interstitial', 'embed'].forEach(function (mode, idx) {
							if (_previewModes.includes(mode)) {
								_availableModes.push(idx + 1);
							}
						});
						_this2.setState({ availableModes: _availableModes });
						return $Try_2_Post();
					} catch ($boundEx) {
						return $error($boundEx);
					}
				};try {
					return Promise.resolve(getPreviewModes({ videoUUID: videoUUID })).then(function ($await_5) {
						try {
							data = $await_5;
							return $Try_2_Post();
						} catch ($boundEx) {
							return $Try_2_Catch($boundEx);
						}
					}, $Try_2_Catch);
				} catch (error) {
					$Try_2_Catch(error)
				}
			});
		};
		apiCalls();
	};

	App.prototype.componentWillUnmount = function componentWillUnmount() {
		window.removeEventListener('message', this.communicator);
	};

	App.prototype.render = function render() {
		var ismobile = mobileCheck();
		var islandscape = landscapeCheck();
		var parentclass = (ismobile ? 'mobile' : '') + ' ' + (islandscape ? 'landscape' : 'portrait');
		return Object(preact_min["h"])(theatre_Theatre, {
			parentclass: parentclass,
			ismobile: ismobile,
			islandscape: islandscape,
			playerReady: this.state.playerReady,
			availableModes: this.state.availableModes,
			aspectRatio: this.state.aspectRatio
		});
	};

	return App;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./index.js



/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "Xkos":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "takr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.js